<template>
    <div>
        <div style="text-align:left;color:#606266;margin-left:50px;margin-top:50px;font-size:17px;" v-if="expert_apply_status=='未申请'"><span>我们欢迎优质内容创作者成为我们的专家，共同创作内容，在此之前，为了更好地了解您，请核对或补充您的如下信息：</span></div>
        <el-form :model="form" label-width="200px" label-position="left" style="width:500px;margin-left:50px;margin-top:30px;" v-if="expert_apply_status=='未申请'">
            <!-- <el-form-item label="我的头像" v-show="reg_type=='wechat'">
                <div style="height:40px;">
                    <el-avatar :src="form.avatar_src" :fit="fit">
                        <img src="https://cube.elemecdn.com/e/fd/0fc7d20532fdaf769a25683617711png.png"/>
                    </el-avatar>
                </div>
            </el-form-item> -->
            <el-form-item label="姓名">
                <el-input v-model="form.name" style="width:250px;"></el-input>
            </el-form-item>
            <el-form-item label="擅长领域">
                <el-input v-model="form.field" style="width:250px;"></el-input>
            </el-form-item>
            <el-form-item label="工作履历">
                <el-input v-model="form.career" type="textarea" :autosize="{ minRows: 3, maxRows: 10}" style="width:250px;"></el-input>
            </el-form-item>
            <el-form-item label="联系方式(微信号/手机号)">
                <el-input v-model="form.contact" style="width:250px;"></el-input>
            </el-form-item>
            <div style="padding-right:430px; margin-top:40px;">
                <el-button type="primary" @click="apply_tobe_expert">申请</el-button>
            </div>
        </el-form>
        <div v-if="expert_apply_status=='审核中'" style="width:100%;text-align:center;padding-top:20%;">
            <span style="font-size:22px;color:#409EFF;font-weight:500;">专家申请已提交，正在审核中，请耐心等待！</span>
        </div>
        <div v-if="expert_apply_status=='审核通过'" style="width:100%;text-align:center;padding-top:20%;">
            <span style="font-size:22px;color:#67C23A;font-weight:500;">专家申请已审核通过，欢迎您的加入！</span>
        </div> 
        <div v-if="expert_apply_status=='审核未通过'" style="width:100%;text-align:center;padding-top:20%;">
            <span style="font-size:22px;color:#F56C6C;font-weight:500;">专家申请审核失败！</span><br>
            <el-button type="primary" size="mini" @click="show_reason">查看原因</el-button>
            <el-button type="primary" size="mini" @click="apply_again">再次申请</el-button>
        </div> 
    </div>
</template>

<script>
import postdata from "@/api/postData.js";
import getdata from "@/api/getData.js";
export default {
    created() {
        this.getExpertApplyStatus();
    },
    data() {
        return {
            form: {'name': '', 'field': '', 'career': '', 'contact': ''},
            expert_apply_status: '',
            apply_failed_reason: '',
        }
    },
    methods: {
        getUserData() {
            getdata.getList("getGLYFUserData")
            .then(resp => {
                if(resp.data.code == 200){
                    this.form = resp.data.data;
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        apply_tobe_expert() {
            postdata.postList("applyTobeExpert", JSON.stringify(this.form))
            .then(resp => {
                if(resp.data.code == 200){
                    this.$message({
                    message: resp.data.message,
                    type: 'success',
                    })
                    this.expert_apply_status = '审核中';
                }else{
                    this.$message({
                    message: resp.data.message,
                    type: 'error',
                    duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        getExpertApplyStatus() {
            getdata.getList("getExpertApplyStatus")
            .then(resp => {
                if(resp.data.code == 200){
                    this.expert_apply_status = resp.data.data;
                    this.apply_failed_reason = resp.data.reason;
                    if(this.expert_apply_status=='未申请'){
                        this.getUserData();
                    }
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
        show_reason() {
            this.$alert(this.apply_failed_reason, '原因', {
            confirmButtonText: '知道了',
            });
        },
        apply_again() {
            getdata.getList("clearExpertApplyStatus")
            .then(resp => {
                if(resp.data.code == 200){
                    this.expert_apply_status = '未申请';
                }else{
                    this.$message({
                    message: resp.data.message,
                    type: 'error',
                    duration: 6000,
                    })
                }
            })
            .catch(err => {
                console.log(err);
            });
        },
    },
}
</script>

<style scoped>
::v-deep .el-form-item__label {
    font-size: 16px;
}
::v-deep .el-form-item__content {
    font-size: 16px;
    text-align: left;
}
</style>